import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Space,
  Dropdown,
  Menu,
  Collapse,
  Select,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import {
  setFilterObj as set_WM_FilterObj,
  setX_attribute,
  setY_attribute,
} from "../../../../redux/actions/WidgetMaker/GraphConfig";

const { Option } = Select;

const CustomAttributeModal = ({
  setVisible,
  visible,
  dashboard,
  addDashboardModal,
}) => {
  const dispatch = useDispatch();
  const [numericBox, setNumericBox] = useState(false);
  const [parametersBox, setParametersBox] = useState(false);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );

  const modalClose = () => {
    setVisible(false);
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [
            {
              parameters: {
                attribute: null,
                display_name: null,
                data_type: null,
                selected: true,
              },
              operator: { value: null, selected: false },
              pair: {
                parameters: {
                  attribute: null,
                  display_name: null,
                  data_type: null,
                  selected: false,
                },
                numeric: { value: null, selected: false },
              },
              combined_operator: {
                value: null,
                selected: false,
              },
            },
          ],
        },
      })
    );
  };

  const saveCustomAttribute = () => {
    let arr = widgetGraphConfig?.custom_attribute?.custom_column;

    let str = JSON.stringify(arr);

    str = str.replace(/[{}]/g, "");
    str = str.replace(/combined_operator/g, "|");
  };

  const addNewColumn = (name) => {
    if (name === "Numeric Text Box") {
      setNumericBox(true);
      setParametersBox(false);
    } else {
      setParametersBox(true);
      setNumericBox(false);
    }
  };

  const removeNewColumn = (name) => {
    setParametersBox(false);
  };

  const menu = (
    <Menu style={{ width: "15rem" }}>
      <Menu.Item
        className="text_regular"
        onClick={() => addAttribute("Numeric Text Box")}
      >
        Numeric Text Box
      </Menu.Item>
      <Menu.Item
        className="text_regular"
        onClick={() => addAttribute("Parameters")}
      >
        Parameters
      </Menu.Item>
    </Menu>
  );

  const operators = [
    {
      id: 1,
      name: "+",
      value: "+",
    },
    {
      id: 2,
      name: "-",
      value: "-",
    },
    {
      id: 3,
      name: "x",
      value: "x",
    },
    {
      id: 4,
      name: "/",
      value: "/",
    },
  ];

  const operatorList = operators.map((el, i) => (
    <Option key={i} value={el?.value}>
      {el?.name}
    </Option>
  ));

  const parameters = [
    {
      id: 2,
      name: "Engagement",
    },
    {
      id: 3,
      name: "Impression",
    },
    {
      id: 4,
      name: "Likes",
    },
    {
      id: 5,
      name: "Comments",
    },
    {
      id: 6,
      name: "Retweet",
    },
  ];

  const parametersList = parameters.map((el, i) => (
    <Option key={i} value={el?.name}>
      {el?.name}
    </Option>
  ));

  const updateAttribute = (groupType, index) => {
    let type = groupType === "Parameters" ? "parameters" : "numeric";
    const updatedGroup =
      widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
        if (i === index) {
          d.operator.selected = true;
          d.pair[type].selected = true;
        }
        return d;
      });

    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedGroup],
        },
      })
    );
  };

  const addAttribute = (groupType) => {
    let index = widgetGraphConfig?.custom_attribute?.custom_column?.length - 1;
    // updating previous object for combined_operator
    const updatedCombinedOperator =
      widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
        if (i === index) {
          d.combined_operator.selected = true;
        }
        return d;
      });
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedCombinedOperator],
        },
      })
    );

    // adding new object
    let type = groupType === "Parameters" ? "parameters" : "numeric";
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [
            ...widgetGraphConfig?.custom_attribute?.custom_column,
            {
              [type]:
                type === "numeric"
                  ? {
                      value: null,
                      selected: true,
                    }
                  : {
                      attribute: null,
                      display_name: null,
                      data_type: null,
                      selected: true,
                    },
              operator: { value: null, selected: false },
              pair: {
                parameters: {
                  attribute: null,
                  display_name: null,
                  data_type: null,
                  selected: false,
                },
                numeric: { value: null, selected: false },
              },
              combined_operator: {
                value: null,
                selected: false,
              },
            },
          ],
        },
      })
    );
  };

  const handleParameters = (name, index, type) => {
    const updatedParameters =
      widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
        if (i === index && type === "pair") {
          d.pair.parameters.attribute = name;
        } else if (i === index) {
          d.parameters.attribute = name;
        }
        return d;
      });

    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedParameters],
        },
      })
    );
  };

  const handleOperator = (value, index) => {
    const updatedOperator =
      widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
        if (i === index) {
          d.operator.value = value;
        }
        return d;
      });

    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedOperator],
        },
      })
    );
  };

  const handleNumeric = (e, index, type) => {
    const updatedNumeric =
      widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
        if (i === index && type === "pair") {
          d.pair.numeric.value = e.target.value;
        } else if (i === index) {
          d.numeric.value = e.target.value;
        }
        return d;
      });
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedNumeric],
        },
      })
    );
  };

  const handleCombinedOperator = (value, index) => {
    const updatedCombinedOperator =
      widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
        if (i === index) {
          d.combined_operator.value = value;
        }
        return d;
      });

    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedCombinedOperator],
        },
      })
    );
  };

  const removeParametersField = (index, type) => {
    let prevIndex = index - 1;
    let updatedParameters;

    if (type === "pair") {
      updatedParameters =
        widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
          if (i === index) {
            d.pair.parameters.selected = false;
            d.pair.parameters.value = null;
            d.operator.selected = false;
          }
          return d;
        });
    } else {
      updatedParameters =
        widgetGraphConfig?.custom_attribute?.custom_column?.map((d, i) => {
          if (i === prevIndex) {
            d.combined_operator.selected = false;
          }
          return d;
        });
      updatedParameters = updatedParameters?.filter((d, i) => i !== index);
    }

    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedParameters],
        },
      })
    );
  };

  const removeNumericField = (index, type) => {
    let prevIndex = index - 1;
    let updatedNumeric;

    if (type === "pair") {
      updatedNumeric = widgetGraphConfig?.custom_attribute?.custom_column?.map(
        (d, i) => {
          if (i === index) {
            d.pair.numeric.selected = false;
            d.pair.numeric.value = null;
            d.operator.selected = false;
          }
          return d;
        }
      );
    } else {
      updatedNumeric = widgetGraphConfig?.custom_attribute?.custom_column?.map(
        (d, i) => {
          if (i === prevIndex) {
            d.combined_operator.selected = false;
          }
          return d;
        }
      );
      updatedNumeric = updatedNumeric?.filter((d, i) => i !== index);
    }

    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        [`custom_attribute`]: {
          [`custom_column`]: [...updatedNumeric],
        },
      })
    );
  };

  return (
    <Modal
      visible={visible}
      className={`p-0 previewModal ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
      title={`Create formula for { ${widgetGraphConfig?.custom_attribute?.name} }`}
      width={"80%"}
      height={"80%"}
      style={{ top: "3rem" }}
      onCancel={modalClose}
      footer={[
        <Button type="button" onClick={modalClose}>
          Close
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={saveCustomAttribute}
        >
          Save
        </Button>,
      ]}
    >
      <div
        className="custom_scroll1 m-2 p-15"
        style={{ height: "40rem", overflow: "auto" }}
      >
        <div className="d-flex flex-wrap align-items-center w-100">
          {widgetGraphConfig?.custom_attribute?.custom_column?.map((d) => {
            return <span className="wm-custom-attribute-bracket">(</span>;
          })}
          {/* if else for initial brackets */}
          {/* <span className="wm-custom-attribute-bracket">(</span> */}
          {/* Start here logic */}
          {widgetGraphConfig?.custom_attribute?.custom_column?.map(
            (data, i) => {
              return (
                <>
                  {data?.parameters?.selected && (
                    <>
                      {i > 0 &&
                        (data?.pair?.numeric?.selected ||
                          data?.pair?.parameters?.selected) && (
                          <span className="wm-custom-attribute-bracket">(</span>
                        )}
                      <div className="wm-custom-att-parameters-list floating-label-group header-brands">
                        <Select
                          dropdownClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                          onChange={(e) => handleParameters(e, i)}
                          placeholder="Parameters"
                          style={{ width: "20rem" }}
                          suffixIcon={
                            <CloseOutlined
                              onClick={() => removeParametersField(i)}
                            />
                          }
                        >
                          {parametersList}
                        </Select>
                        <label
                          className="portlet-label floating-label bg__white font-size12"
                          style={{ top: "-0.8rem" }}
                        >
                          Parameters
                        </label>
                      </div>
                    </>
                  )}

                  {data?.numeric?.selected && (
                    <>
                      {(data?.pair?.numeric?.selected ||
                        data?.pair?.parameters?.selected) && (
                        <span className="wm-custom-attribute-bracket">(</span>
                      )}
                      <div className="wm-custom-att-numeric-list floating-label-group header-brands">
                        <Input
                          required
                          type="number"
                          id="outlined-required"
                          size="small"
                          onChange={(e) => handleNumeric(e, i)}
                        />
                        <label className="portlet-label floating-label">
                          Numeric Text Box
                        </label>
                      </div>
                    </>
                  )}

                  {/* inner button / hide and show */}
                  {!data.operator?.selected && (
                    <>
                      <div className="custom-att-parameters-btn">
                        <Dropdown
                          overlay={
                            <Menu style={{ width: "15rem" }}>
                              <Menu.Item
                                className="text_regular"
                                onClick={() =>
                                  updateAttribute("Numeric Text Box", i)
                                }
                              >
                                Numeric Text Box
                              </Menu.Item>
                              <Menu.Item
                                className="text_regular"
                                onClick={() => updateAttribute("Parameters", i)}
                              >
                                Parameters
                              </Menu.Item>
                            </Menu>
                          }
                          placement="bottomRight"
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <Button
                            type="primary"
                            size="small"
                            className="wm-plus-icon"
                          >
                            +
                          </Button>
                        </Dropdown>
                      </div>
                      {widgetGraphConfig?.custom_attribute?.custom_column
                        ?.length > 1 && (
                        <span
                          className={`wm-custom-attribute-bracket ${
                            i ==
                            widgetGraphConfig?.custom_attribute?.custom_column
                              ?.length -
                              1
                              ? "d-none"
                              : ""
                          }`}
                        >
                          )
                        </span>
                      )}
                    </>
                  )}

                  {/* pair condition parameters or numeric */}
                  {data?.pair?.numeric?.selected ? (
                    <>
                      <div className="wm-custom-att-operator-list">
                        <Select
                          defaultValue="+"
                          onChange={(e) => handleOperator(e, i)}
                          style={{ width: "6rem" }}
                          dropdownClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          {operatorList}
                        </Select>
                      </div>
                      <div className="wm-custom-att-numeric-list floating-label-group header-brands">
                        <Input
                          required
                          type="number"
                          id="outlined-required"
                          onChange={(e) => handleNumeric(e, i, "pair")}
                        />
                        <label className="portlet-label floating-label">
                          Numeric Text Box
                        </label>
                      </div>
                      {widgetGraphConfig?.custom_attribute?.custom_column
                        ?.length > 1 && (
                        <span className="wm-custom-attribute-bracket">)</span>
                      )}
                      {i !== 0 &&
                        i !==
                          widgetGraphConfig?.custom_attribute?.custom_column
                            ?.length -
                            1 && (
                          <span className="wm-custom-attribute-bracket">)</span>
                        )}
                    </>
                  ) : (
                    data?.pair?.parameters?.selected && (
                      <>
                        <div className="wm-custom-att-operator-list">
                          <Select
                            defaultValue="x"
                            onChange={(e) => handleOperator(e, i, "pair")}
                            style={{ width: "6rem" }}
                            dropdownClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            {operatorList}
                          </Select>
                        </div>
                        <div className="wm-custom-att-parameters-list floating-label-group header-brands">
                          <Select
                            onChange={(e) => handleParameters(e, i, "pair")}
                            placeholder="Parameters"
                            style={{ width: "20rem" }}
                            dropdownClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                            suffixIcon={
                              <CloseOutlined
                                onClick={() => removeParametersField(i, "pair")}
                              />
                            }
                          >
                            {parametersList}
                          </Select>
                          <label
                            className="portlet-label floating-label bg__white font-size12"
                            style={{ top: "-0.8rem" }}
                          >
                            Parameters
                          </label>
                        </div>
                        {widgetGraphConfig?.custom_attribute?.custom_column
                          ?.length > 1 && (
                          <span className="wm-custom-attribute-bracket">)</span>
                        )}
                        {i !== 0 &&
                          i !==
                            widgetGraphConfig?.custom_attribute?.custom_column
                              ?.length -
                              1 && (
                            <span className="wm-custom-attribute-bracket">
                              )
                            </span>
                          )}
                      </>
                    )
                  )}

                  {/* combined operator */}
                  {data?.combined_operator?.selected && (
                    <>
                      {/* {i == 0 ? (
                          ""
                        ) : (
                          <span className="wm-custom-attribute-bracket">)</span>
                        )} */}
                      {/* <span className="wm-custom-attribute-bracket">)</span> */}
                      <div className="wm-custom-att-operator-list">
                        <Select
                          defaultValue="+"
                          onChange={(e) => handleCombinedOperator(e, i)}
                          style={{ width: "6rem" }}
                          dropdownClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          {operatorList}
                        </Select>
                      </div>
                      {/* <span className="wm-custom-attribute-bracket">(</span> */}
                    </>
                  )}
                </>
              );
            }
          )}
          &nbsp;
          {/* if else for initial brackets */}
          {widgetGraphConfig?.custom_attribute?.custom_column?.length == 1 ? (
            <span className="wm-custom-attribute-bracket">)</span>
          ) : (
            <span className="wm-custom-attribute-bracket">)</span>
          )}
          {/* <span className="wm-custom-attribute-bracket">)</span> */}
          {/* {widgetGraphConfig?.custom_attribute?.custom_column?.length > 1 && (
              <span className="wm-custom-attribute-bracket">)</span>
            )} */}
          {/* aading new object in array */}
          <div className="custom-att-parameters-btn">
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              disabled={
                widgetGraphConfig?.custom_attribute?.custom_column?.length >= 5
                  ? true
                  : false
              }
              overlayClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              <Button type="primary" size="small" className="wm-plus-icon">
                +
              </Button>
            </Dropdown>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CustomAttributeModal;
